module.exports = __webpack_public_path__ + "static/media/kids.52d531ea.png";